import React from 'react';
import { createPortal } from 'react-dom';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import BusyModal from '../../modals/busy';

export default ({
    children,
    title,
    onCancel = () => {},
    onSave = () => {},
    disabled = false,
    busy
}) => {
    if (busy) {
        return (<BusyModal title='Updating...' centered/>)
    }

    return createPortal(
        <Modal
            show
            onHide={() => onCancel()}
            size='lg'
            backdrop='static'
        >
            <Modal.Header closeButton >
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {children}
                </Form>
                <Row>
                    <Col md={{ span: 4, offset: 8}}>
                        <Row>
                            <Col><Button block onClick={() => onSave()} disabled={disabled}>Update Selected</Button></Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
        , document.body)
};
